module.exports = __webpack_public_path__ + "img/itch.ff930e5f.png";